import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IntegrationsApiService } from '@core/integrations-http-legacy';

import type { Source } from '../../../types';
import { sourceCompoundId } from '../../../utils';

@Injectable({ providedIn: 'root' })
export class SourceHttpClient {
  private readonly httpApi = inject(IntegrationsApiService);

  public fetch(): Observable<Source[]> {
    return this.httpApi
      .get('field-mapping/sources')
      .pipe(map(({ sources }: { sources: Source[] }) => this.uniqSources(sources)));
  }

  private uniqSources(sources: Source[]): Source[] {
    const groupedById = sources.reduce(
      (acc, source) => {
        const compoundId = sourceCompoundId(source);
        acc[compoundId] = acc[compoundId]
          ? {
              ...acc[compoundId],
              templateName: `${acc[compoundId].templateName}, ${source.templateName}`,
            }
          : { ...source, compoundId };
        return acc;
      },
      <Record<string, Source>>{},
    );
    return Object.values(groupedById);
  }
}
